import { Icon } from '@chakra-ui/icons';

export const GameIcon = ({ color = 'action' }: { color?: string }) => (
	<Icon
		width="12px"
		height="13px"
		viewBox="0 0 12 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M3.16602 8.22168H9.01207"
			stroke={color}
			strokeWidth="1.01231"
			strokeLinecap="round"
		/>
		<circle
			cx="6.0584"
			cy="2.81866"
			r="2.01636"
			stroke={color}
			strokeWidth="1.16416"
		/>
		<path
			d="M3.20266 8.22168H1.61558C1.57792 8.22168 1.54338 8.24258 1.5259 8.27594L0.61312 10.0185C0.605528 10.033 0.601562 10.0491 0.601562 10.0655V12.3068C0.601562 12.3627 0.646886 12.4081 0.702794 12.4081H11.356C11.412 12.4081 11.4573 12.3627 11.4573 12.3068V10.2666C11.4573 10.2509 11.4536 10.2354 11.4466 10.2213L10.4748 8.27764C10.4576 8.24334 10.4226 8.22168 10.3842 8.22168H8.9068"
			stroke={color}
			strokeWidth="1.01231"
			strokeLinecap="round"
		/>
		<path
			d="M5.05859 4.63086V7.981"
			stroke={color}
			strokeWidth="1.01231"
			strokeLinecap="round"
		/>
		<path
			d="M7.05859 4.63086V7.981"
			stroke={color}
			strokeWidth="1.01231"
			strokeLinecap="round"
		/>
	</Icon>
);
